import { defineComponent as _defineComponent } from 'vue';
import { ref, watch, onUnmounted } from 'vue';
import { useApp } from '@/use/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    scrollableContent: {
      default: () => {
        return {
          scrollable: false,
          contentHeight: ''
        };
      }
    },
    closeDelay: {
      default: 0
    },
    hideOverlay: {
      type: Boolean,
      default: false
    },
    modalCardProps: null
  },
  emits: ['input', 'click:close', 'modal-closed', 'close:cancel'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const activator = ref(null);
    const modalOpen = ref(props.value);
    const {
      isAModalOpen
    } = useApp();
    /*
      if a modal is already open we should keep that value in case
      a modal mounts AFTER the first one is already open
    */
    isAModalOpen.value = isAModalOpen.value || modalOpen.value;
    // Put a ref on this component and call the below functions to open/close the modal
    const show = () => {
      modalOpen.value = true;
      isAModalOpen.value = true;
    };
    const close = () => {
      if (!modalOpen.value) return;
      modalOpen.value = false;
      isAModalOpen.value = false;
      emit('input', false);
      // move to value prop and get rid of the emits below
      emit('click:close');
      emit('modal-closed');
    };
    watch(() => props.value, () => {
      isAModalOpen.value = props.value;
      if (props.value) {
        modalOpen.value = true;
      } else {
        close();
      }
    });
    onUnmounted(() => {
      /*
        Sometimes the component unmounts to close instead
        of emitting input
        so this is a fall back that if this modal was open
        and gets unmounted set isAModalOpen back to false
        if this was not already open dont update global value
      */
      if (modalOpen.value) {
        isAModalOpen.value = false;
      }
    });
    expose({
      show,
      close,
      modalOpen
    });
    return {
      __sfc: true,
      props,
      emit,
      activator,
      modalOpen,
      isAModalOpen,
      show,
      close
    };
  }
});